var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"mt-2 mb-5 text-center"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("© 2020. Activa Media")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }